import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { makeStyles, Theme } from '@lifeomic/chroma-react/styles';
import moment from 'moment';
import { Chip } from '@lifeomic/chroma-react/components/Chip';
import { FilterTimes } from './types';

const messages = defineMessages({
  filterTimesChipLabel: {
    id: 'pages.auditLog.filterTimesChipLabel',
    defaultMessage: '{minDate} to {maxDate}',
  },
});

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    margin: theme.spacing(0, 0.5),
  },
}));

interface TimeFilterChipProps {
  filterTimes: FilterTimes;
  setFilterTimes: (FilterTimes: FilterTimes) => void;
}

const TimeFilterChip: React.FC<TimeFilterChipProps> = ({
  filterTimes,
  setFilterTimes,
}) => {
  const { formatMessage } = useIntl();
  const classes = useStyles({});

  if (filterTimes.minTime === 0) return null;
  return (
    <Chip
      label={formatMessage(messages.filterTimesChipLabel, {
        minDate: moment(filterTimes.minTime).format('MMM D, YYYY H:mm'),
        maxDate: moment(filterTimes.maxTime).format('MMM D, YYYY H:mm'),
      })}
      onDelete={() =>
        setFilterTimes({ maxTime: Date.now() + 1000, minTime: 0 })
      }
      className={classes.root}
    />
  );
};

export default React.memo(TimeFilterChip);
